<template>
  <section class="viewsrhqyBasicManage_coordinate p-4 space-y-4">
    <viewTitle
      title="业务管理 / 基础数据管理 / 货物种类管理"
      :showReturn="false"
    />
    <el-button
      v-has="['c-base-mp-goods-add']"
      @click="onAdd"
      size="medium"
      type="primary"
      >添加</el-button
    >
    <el-button
      v-has="['c-base-mp-goods-import']"
      @click="showImport = true"
      size="medium"
      >导入</el-button
    >
    <el-button
      v-has="['c-base-mp-goods-export']"
      @click="onExport"
      size="medium"
      >导出</el-button
    >
    <el-button
      v-has="['c-base-mp-goods-delete']"
      @click="onDelete"
      size="medium"
      >删除</el-button
    >
    <div class="space-x-4">
      <span class="text-sm">车辆业务类型</span>
      <el-input
        v-model="queryParam.car_business_name"
        clearable
        placeholder="请输入车辆业务类型"
        class="w-60"
      ></el-input>
      <span class="text-sm">货物种类</span>
      <el-input
        v-model="queryParam.goods_name"
        clearable
        placeholder="请输入货物种类名称"
        class="w-60"
      ></el-input>
    </div>
    <c-table
      isSelection
      :selection.sync="rowKeySelection"
      :isIndex="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      @loadPage="loadData"
    >
      <template slot="update_time" slot-scope="scope">
        {{ scope.row.update_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="scope">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link
            v-has="['c-base-mp-goods-update']"
            @click="onEdit(scope.row)"
            label="修改"
          ></c-link>
          <c-link
            @click="onDelete(scope.row, 1)"
            label="删除"
            v-has="['c-base-mp-goods-delete']"
            type="danger"
          ></c-link>
        </el-row>
      </template>
    </c-table>
    <c-import
      v-bind="importOptions"
      :show.sync="showImport"
      @finish="refreshData"
    >
      <span slot="desc">
        <span>
          3、仅支持模板信息格式，请勿填写其他数据内容
        </span>
        <br />
      </span>
    </c-import>
    <goodsTypeModal ref="goodsTypeModal" @ok="onSearch"></goodsTypeModal>
  </section>
</template>
<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import goodsTypeModal from "./components/goodsTypeModal.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showImport: false,
      importOptions: {
        downloadDemoName: "货物种类导入模板",
        templateUrl:
          "/api/queue/admin/download_template?file_name=import_goods.xlsx",
        importUrl: "/api/queue/admin/import_goods_type"
      },
      columns: [
        {
          label: "基地",
          prop: "baseName",
          formatData: () => this.baseInfo.com_name
        },
        { label: "车辆业务类型", prop: "car_business_name" },
        { label: "货物种类", prop: "name" },
        { label: "备注", prop: "remark" },
        // { label: '维护人', prop: 'update_name' },
        { width: 180, label: "最近维护时间", prop: "update_time" },
        { label: "操作", prop: "action", width: 120 }
      ],
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_goods_type",
          data: params
        }),
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除货物种类？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_goods_type"
      },
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_goods_type",
          data: params,
          noLoading: true
        });
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  components: {
    goodsTypeModal
  },
  methods: {
    onAdd() {
      this.$refs.goodsTypeModal.openModal();
    },
    onEdit(row) {
      this.$refs.goodsTypeModal.openModal(row);
    }
  },
  mixins: [initListMinxin, mixinTableLyout]
};
</script>
